import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { Observable } from 'rxjs'
import { distinctUntilChanged, map } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { Store } from '@ngrx/store'
import { configurationOptionSelectors } from '../configuration-option.selectors'
import { ConfigurationOptionService } from '../configuration-option.service'

@Component({
  selector: 'configuration-option-employee-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionEmployeeTabComponent implements OnInit {
  public configFormValues$: Observable<any>
  public isLoading$: Observable<boolean>
  public isCollapsed = false

  public form: UntypedFormGroup
  public accessRights = AccessRights
  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private configOptionService: ConfigurationOptionService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      ogoneurl: ['', []],
      sales_person: ['', [Validators.min(0)]]
    })

    this.configFormValues$ = this.store
      .select(configurationOptionSelectors.selectAll)
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b)),
        map((configOptions) =>
          this.configOptionService.mapEntitiesToObject(configOptions)
        )
      )

    this.isLoading$ = this.store.select(
      configurationOptionSelectors.selectIsLoading
    )
  }
}
